import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

//* ~~~~~~ ARTICLES ROUTES ~~~~~~

// Gets articles
export const getArticles = async (keyword = '') => {
  let keywordQuery = ''
  if (keyword.length > 0) {
    keywordQuery = `?keywords=${encodeURIComponent(
      keyword.trim().toLocaleLowerCase().slice(0, 20)
    )}`
  }
  return (await wrapCall({
    method: callGet,
    uri: `/articles${keywordQuery}`
  })) as APIArticleRoot
}

// Submits a new article
export const postArticle = async (data: APIArticleUpdate) => {
  return (await wrapCall({
    method: callPost,
    uri: '/articles',
    data
  })) as APIArticleGeneral
}

// Gets a single article by id
export const getArticle = async (id: string) => {
  return (await wrapCall({
    method: callGet,
    uri: `/articles/${id}`
  })) as APIArticleGeneral
}

// Update an article
export const putArticle = async (id: string, data: APIArticleUpdate) => {
  return (await wrapCall({
    method: callPut,
    uri: `/articles/${id}`,
    data
  })) as APIArticleGeneral
}

// Delete an article
export const deleteArticle = async (id: string) => {
  return await wrapCall({ method: callDelete, uri: `/articles/${id}` })
}
